import React from 'react';

import { useRecoilValue } from 'recoil';
import { selectedShipmentState } from '../../states/shipment';
import ShipmentDetail from '../../components/ShipmentDetail';
import { Paper, LinearProgress } from '@mui/material';
import { H2, H3 } from '../../components/Heading';

import AddressContainer from '../Address';
import CustomerProfileContainer from '../CustomerProfile';
import ClientLogoContainer from '../ClientLogo';
import { selectedProfileState } from '../../states/profile';

const styles = {
  error: { border: 'solid 1px #f4485e', borderLeft: 'solid 8px #f4485e', padding: '10px', borderRadius: '5px' },
  success: { border: 'solid 2px #75c31e', borderLeft: 'solid 8px #75c31e', padding: '10px', borderRadius: '5px' },
  failed: { border: 'solid 2px #4a4a4a', borderLeft: 'solid 8px #4a4a4a', padding: '10px', borderRadius: '5px' },
  normal: { padding: '15px' },
  item: {
    fontSize: '15px',
    padding: '2px',
    color: '#5a5a5a',
  },
  header: {
    fontSize: '1.2em',
    fontWeight: 500,
  },
};

function ShipmentDetailContainer() {
  const shipment = useRecoilValue(selectedShipmentState);
  const profile = useRecoilValue(selectedProfileState);
  const style = !shipment || shipment.status === 'GEOCODE_FAILED' || shipment.status === 'CANCELLED_BEFORE_PICKUP' ? styles.error : styles.success;
  const { dropoff_address, client_id } = shipment || {};
  const { address } = profile || {};

  return (
    <Paper sx={{ ...style, flex: 1 }}>
      <div style={{ display: 'flex', padding: 0 }}>
        <div style={{ flex: 1 }}>
          <H2>Shipment Info</H2>
        </div>
        <div style={{ marginTop: '-10px' }}>
          <ClientLogoContainer id={client_id} />
        </div>
      </div>

      {shipment && <ShipmentDetail shipment={shipment} />}

      <H3>Customer Profile Info</H3>
      <div style={{ marginBottom: '10px' }}>
        <React.Suspense fallback={<LinearProgress />}>
          <CustomerProfileContainer originalAddress={address || dropoff_address} />
        </React.Suspense>
      </div>
      <React.Suspense fallback={<LinearProgress />}>{shipment && <AddressContainer shipment={shipment} />}</React.Suspense>
    </Paper>
  );
}

export default ShipmentDetailContainer;
